import { defineMessages } from 'react-intl';

export default defineMessages({
  confirmationButton: {
    id: 'legal-proceedings.risk.confirmation_button_title',
  },
  cancelButton: {
    id: 'legal-proceedings.risk.cancel_button_title',
  },
  appealCompensationAmount: {
    id: 'legal-proceedings.risk.risk_information.appeal_compensation_amount',
  },
  judgementCompensationAmount: {
    id: 'legal-proceedings.risk.risk_information.judgement_compensation_amount',
  },
  reason: {
    id: 'legal-proceedings.risk.dialog.judgement_amount.update_reason',
  },
  judgement: {
    id: 'legal-proceedings.risk.confirmation_dialog_title.judgement',
  },
  appeal: {
    id: 'legal-proceedings.risk.confirmation_dialog_title.appeal',
  },
  provisionalExecution: { id: 'summary_sheet.provisional_execution' },
  deceasedMedicalFees: {
    id: 'legal-proceedings.risk.risk_information.deceased_medical_fees',
  },
  deceasedFuneralFees: {
    id: 'legal-proceedings.risk.risk_information.deceased_funeral_fees',
  },
});
